import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { ResetPassword } from "../../../@types/auth";
import axiosInstance from "../../../api/manageServer";

interface ResetPasswordState {
  isLoading: boolean;
  error: string | false;
  tokenType: string;
  resetPassword: any;
}

const initialState: ResetPasswordState = {
  isLoading: false,
  error: false,
  tokenType: "Bearer",
  resetPassword: null,
};

const slice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetPasswordSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.resetPassword = action.payload;
    },
    resetPasswordFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Export the reducer
export default slice.reducer;

const { actions } = slice;

// Thunk action for resetting password
export function AuthResetPassword(resetPassword: ResetPassword) {
  return async (dispatch: any) => {
    dispatch(actions.startLoading());
    try {
      const response = await axiosInstance.put(
        "/auth/resetPassword",
        resetPassword
      );
      if (response?.data) {
        dispatch(actions.resetPasswordSuccess(response.data)); 
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.message; 
      dispatch(actions.resetPasswordFailure(errorMessage));
      toast.error(errorMessage); 
    }
  };
}
